import { reads } from '@ember/object/computed';

import { formatMoney, MONEY_TOKENS } from '@repo/design-system-kit/utils/format-money';
import { buildValidations, validator } from 'ember-cp-validations';

import ENV from 'register-partners-js/config/environment';

const MAX_SINGLE_PAYMENT_VALUE = 2100000000;

const validationsRules = {
  name: [
    validator('ds-error'),
    validator('length', { min: 1 }),
    validator('presence', {
      presence: true,
      messageKey: 'generic.required-field.error',
    }),
  ],
  legalRegistrationDate: {
    // we disable legalRegistrationDate validation here for referenced organization because their registration date can be in the future
    disabled: reads('model.underRegistration'),
    validators: [
      validator('ds-error'),
      validator('presence', true),
      validator('date', {
        // The legal registration date needs to be before the first day of the next year
        before: new Date(new Date().getFullYear() + 1, 0, 1),
        after: '1/1/1800',
        format: 'DD/MM/YYYY',
        messageKey: 'validations.errors.date',
      }),
    ],
  },
  addressLineOne: [
    validator('ds-error'),
    validator('presence', {
      presence: true,
      messageKey: 'generic.required-field.error',
    }),
    validator('length', { min: 2 }),
  ],
  addressZipcode: [
    validator('ds-error'),
    validator('presence', {
      presence: true,
      messageKey: 'generic.required-field.error',
    }),
    validator('length', { min: 3, max: 10, messageKey: 'validations.errors.zipcode' }),
  ],
  addressCity: [
    validator('ds-error'),
    validator('presence', {
      presence: true,
      messageKey: 'generic.required-field.error',
    }),
  ],
  addressCountry: [
    validator('ds-error'),
    validator('presence', {
      presence: true,
      messageKey: 'generic.required-field.error',
    }),
  ],
  annualTurnover: [
    validator('presence', {
      presence: true,
      messageKey: 'partner-register-kyb.business-finances.annual-turnover.error-message',
    }),
  ],
  yearlyTransactionVolume: [
    validator('presence', {
      presence: true,
      messageKey: 'partner-register-kyb.business-finances.yearly-transaction-volume.error-message',
    }),
  ],
  maxSinglePaymentAmount: [
    validator('presence', {
      presence: true,
      messageKey: 'partner-register-kyb.business-finances.max-single-payment-amount.error-message',
    }),
    validator('number', {
      allowString: true,
      lte: MAX_SINGLE_PAYMENT_VALUE,
      messageKey:
        'partner-register-kyb.business-finances.max-single-payment-amount.error-message-amount',
      amount: formatMoney({
        amount: MAX_SINGLE_PAYMENT_VALUE,
        token: MONEY_TOKENS.SYMBOL_COMPACT,
      }),
    }),
  ],
};

const OrganizationValidations = buildValidations(validationsRules, {
  debounce: ENV.environment === 'test' ? 0 : 500,
  disabled: reads('model.disableValidations'),
});

export default OrganizationValidations;
